import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LocaleService } from 'src/app/services/locale.service';
import { IModule } from 'src/app/interfaces/IModule';
import { KeycloakService } from 'keycloak-angular';
import { TenantSettingsService } from 'src/app/services/tenantSettings.service';
import { TokenService } from 'src/app/services/token.service';
import { HysteroscopyFileService } from 'src/app/services/hyseroscopyFile.service';
import { Subscription } from 'rxjs';
import { el_GR, en_GB, NzI18nService } from 'ng-zorro-antd/i18n';
import { TerminologyTestingStateService } from 'src/app/services/terminology-testing-state.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false,
})
export class HeaderComponent {
  @Input() activeButton: string = '';
  @Input() menuList: IModule[] | undefined;

  private subscriptions: Subscription[] = [];

  public initials: string = '';
  public name: string = '';
  public surname: string = '';

  public logo: string = '';

  ongoingHysteroscopyExamination: boolean = false;

  defaultLanguage = this.localeService.getCurrentLocale() || 'en';
  defaultTheme = 'light';

  public profileVisible: boolean = false;

  public notificationsVisible: boolean = false;
  readonly provisionalTerminology$ = this.terminologyTestingState.provisional$;

  //language: string = 'en'; // Initial value

  languageOptions = [
    {
      value: 'en',
      label: 'English',
      flag: '../../../../assets/images/flags/en.png',
    },
    {
      value: 'el',
      label: 'Greek',
      flag: '../../../../assets/images/flags/gr.png',
    },
  ];

  themeOptions = [
    {
      value: 'dark',
      label: 'Dark',
    },
    {
      value: 'light',
      label: 'Light',
    },
    {
      value: 'system',
      label: 'System',
    },
  ];

  availableThemes = ['dark', 'light', 'system'];

  public notifications: any = [
    // {
    //   id: 1,
    //   title: 'New Appointment',
    //   message: 'You have a new appointment request.',
    // },
    // {
    //   id: 2,
    //   title: 'System Update',
    //   message: 'System will be down for maintenance tonight.',
    // },
    // {
    //   id: 3,
    //   title: 'Form Reminder',
    //   message: 'Please complete your daily form submission.',
    // },
  ];

  constructor(
    private readonly router: Router,
    private readonly localeService: LocaleService,
    private readonly keycloakService: KeycloakService,
    private readonly tenantService: TenantSettingsService,
    private readonly tokenService: TokenService,
    private hysteroscopyFileService: HysteroscopyFileService,
    private readonly i18n: NzI18nService,
    private readonly terminologyTestingState: TerminologyTestingStateService,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.hysteroscopyFileService
        .getExaminationStatus()
        .subscribe((status: boolean) => {
          if (status) {
            this.ongoingHysteroscopyExamination = status;
          } else {
            this.ongoingHysteroscopyExamination = false;
          }
        })
    );
    this.tenantService.downloadPicture(1).subscribe({
      next: (response) => {
        const reader = new FileReader();
        reader.readAsDataURL(response);
        reader.onload = () => {
          this.logo = reader.result as string;
        };
      },
      error: (error) => {
        console.error('Error downloading picture:', error);
      },
    });

    this.keycloakService.getToken().then((token) => {
      if (token) {
        const base64Decoded = this.tokenService.base64UrlDecode(
          token.split('.')[1]
        );
        const payload = JSON.parse(this.tokenService.utf8Decode(base64Decoded));
        // console.log(payload);
        this.name = payload['given_name'];
        this.surname = payload['family_name'];
        this.initials = (this.name[0] + this.surname[0]).toUpperCase();
      }
    });
  }

  changeTheme(selectedTheme: string) {
    if (selectedTheme) {
      if (selectedTheme == 'dark') {
        // this.i18n.setLocale(en_GB);
      } else if (selectedTheme == 'light') {
        // this.i18n.setLocale(el_GR);
      } else {
      }
      // this.themeService.updateTheme(selectedTheme).subscribe({
      //   next: () => {
      //     const fallbackTheme = 'light';
      //     this.defaultTheme = this.availableThemes.includes(selectedTheme)
      //       ? selectedTheme
      //       : fallbackTheme;

      //     window.location.reload(); // This will refresh the page in order to update the token of the new theme
      //   },
      //   error: (error) => {
      //     console.error('Error updating theme:', error);
      //   },
      // });
    }
  }

  changeLanguage(selectedLanguage: string) {
    if (!selectedLanguage) return;
    const normalized = LocaleService.normalize(selectedLanguage);
    this.localeService.updateLocale(normalized).subscribe({
      next: () => {
        this.defaultLanguage = this.localeService.getCurrentLocale();
        this.i18n.setLocale(this.defaultLanguage.startsWith('el') ? el_GR : en_GB);
      },
      error: (error) => console.error('Error updating locale:', error),
    });
  }

  logoPress() {
    this.router.navigate(['/ehr/' + this?.menuList?.at(0)?.path]);
  }

  openProfile(): void {
    this.profileVisible = true;
  }

  closeProfile(): void {
    this.profileVisible = false;
  }

  openNotifications(): void {
    this.notificationsVisible = true;
  }

  closeNotifications(): void {
    this.notificationsVisible = false;
  }

  viewNotification(notification: any): void {
    console.log('View:', notification);
    // Optional: open modal, navigate, etc.
  }

  deleteNotification(notification: any): void {
    if (this.notifications.length > 0) {
      this.notifications = this.notifications.filter(
        (n: any) => n.id !== notification.id
      );
    }
  }
}
